export default "__VITE_ASSET__DQZk3FxD__"